export type DetailItem = {
  label: string
  value: React.ReactNode
  valueClassName?: string
  className?: string
}
export interface DetailCardProps {
  title: React.ReactNode
  icon: React.ReactElement
  items?: DetailItem[]
  className?: string
  children?: React.ReactElement
  itemLayout?: 'row' | 'col'
  /** Tighter padding and smaller text, for packing many cards into one view. */
  dense?: boolean
}

export default function DetailCard({
  title,
  items,
  className,
  icon,
  children,
  itemLayout = 'row',
  dense = false,
}: DetailCardProps) {
  return (
    <div
      className={`${className ?? ''} bg-base-200 border border-base-content/20 rounded-xl flex flex-col justify-start ${dense ? 'px-3 py-2 gap-1' : 'h-full p-4 gap-4'}`}
    >
      <h3 className={`text-base-content font-semibold flex items-center ${dense ? 'text-sm gap-2' : 'text-lg gap-4'}`}>
        {icon} {title}
      </h3>
      {children ?? (
        <ul className="">
          {items?.map((item) => (
            <li
              key={item.label}
              className={` ${itemLayout === 'col' ? 'flex flex-col gap-1 items-start' : 'flex-row gap-4 items-center justify-between '} flex border-b border-b-base-content/10 last:border-b-0 ${dense ? 'py-0.5 text-xs' : 'py-2 text-sm'} ${item.className ?? ''}`}
            >
              <span className="font-medium text-base-content/80">{item.label}</span>
              <span className={`  text-right ${item.valueClassName ?? 'text-base-content/80'}`}>{item.value}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
